import { parseOptionalPage } from '@/lib/urlUtils';

import type { AircraftSearchResult, AircraftSearchSort } from './types';
import { AIRCRAFT_SEARCH_SORTS } from './utils';

export interface AircraftSearchSearchParams {
    q?: string;
    page?: number;
    matchType?: AircraftSearchResult['matchType'];
    /** The results table's column sort; absent keeps the match-type grouping. */
    sort?: AircraftSearchSort;
}

const MATCH_TYPES: AircraftSearchResult['matchType'][] = [
    'body',
    'filename',
    'doc_type',
];

function isMissing(value: unknown): boolean {
    return value === undefined || value === null || value === '';
}

function parseOptionalString(value: unknown): string | undefined {
    return isMissing(value) ? undefined : String(value);
}

function parseOptionalMatchType(
    value: unknown,
): AircraftSearchResult['matchType'] | undefined {
    return MATCH_TYPES.find((matchType) => matchType === value);
}

function parseOptionalSort(value: unknown): AircraftSearchSort | undefined {
    return AIRCRAFT_SEARCH_SORTS.find((sort) => sort === value);
}

/** Shared by all four search routes; the document ones read `matchType` too. */
export function validateAircraftSearchSearch(
    search: Record<string, unknown>,
): AircraftSearchSearchParams {
    return {
        q: parseOptionalString(search.q),
        page: parseOptionalPage(search.page),
        matchType: parseOptionalMatchType(search.matchType),
        sort: parseOptionalSort(search.sort),
    };
}
